import { render, staticRenderFns } from "./index.vue?vue&type=template&id=502f2b03"
import script from "./index.vue.ts?vue&type=script&lang=ts&external"
export * from "./index.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports